import { Component, OnInit } from '@angular/core';

@Component({
  selector: 's18-returns',
  templateUrl: './returns.component.html',
  styleUrls: ['./returns.component.scss']
})
export class ReturnsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
